<figure class='highcharts-figure'>
    <div id="companyCardChart"></div>
</figure>